export default __webpack_public_path__ + "static/media/sweet-thermal-logo.473c83e2.png";